module.exports = __webpack_public_path__ + "static/Privacy@2x-cb968ac56de96a604754bd551110b587.jpg";